import {DotPath} from '../getOrElse'
import {dateOr} from '.'
import {Decorators} from '../config/getterConfig'

// serves as a marker to utlize the same logic for the date itself
const badDate = new Date('not a date')
export function isoDateStringOr<R extends any, T extends string>(
  root: R,
  path: DotPath = '',
  decorators: Decorators<Date> = [],
  orElse = '' as T
): T {
  return [].concat(
    dateOr(root, path, decorators, badDate)
  ).map(
    date =>
      (date === badDate) ? orElse : date.toISOString()
  ).shift() as T
}